import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IPcr } from '../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../user/selectors'
import { getPatientMedicationsSelector } from '../selectors'
import { setSavePatientMedicationsResponse } from '../store/patientMedications.actions'
import { PatientMedicationsConstants } from '../store/patientMedications.constants'
import { IPatientMedicationsState } from '../store/patientMedications.types'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { setHasPatient } from '../../patientInformation/store/patientInformation.actions'

export function* savePatientMedications() {
  const patientMedications: IPatientMedicationsState = yield select(getPatientMedicationsSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const { patientMedicationsList, lastOralIntake } = patientMedications
    const newPatientMedicationsList = patientMedicationsList.filter(
      (medication) =>
        (medication.name !== null && medication.name.name !== '') ||
        (medication.dose !== null && medication.dose !== '') ||
        medication.doseUnits !== null ||
        medication.route !== null ||
        medication.frequency !== null
    )
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    const pcrDocUpdated = {
      ...pcrDoc,
      patient: {
        ...pcrDoc.patient,
        patientMedications: {
          ...patientMedications,
          patientMedicationsList: newPatientMedicationsList,
          lastOralIntake: lastOralIntake,
        },
      },
    }
    try {
      yield put(setHasPatient(true))
      const response: string = yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
      yield put(setSavePatientMedicationsResponse(response))
    } catch (e) {
      yield put(throwPcrException(`savePatientMedications() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* savePatientMedicationsSaga() {
  yield takeLatest(
    [PatientMedicationsConstants.SAVE_PATIENT_MEDICATIONS, PatientMedicationsConstants.SET_LAST_ORAL_INTAKE],
    performWithMutexHOG,
    savePatientMedications
  )
}
